export default "__VITE_ASSET__a0955664__"